<template>
    <div
        class="mt-auto ml-auto"
        :class="isRecurring ? 'mb-2' : 'mb-auto'"
    >
        <div>
            <div
                v-if="!isFullPage"
                class="d-flex align-center"
            >
                <v-tooltip
                    bottom
                    open-delay="250"
                >
                    <template v-slot:activator="{ on }">
                        <icon-button
                            :color="taskData.is_extra ? 'orange' : 'n3'"
                            :on="on"
                            icon="BookmarkPlus"
                            @click="toggle_field('is_extra')"
                        />
                    </template>
                    <span>{{ $t("Extra work") }}</span>
                </v-tooltip>
                <v-tooltip
                    bottom
                    open-delay="250"
                >
                    <template v-slot:activator="{ on }">
                        <icon-button
                            :color="taskData.is_important ? 'orange' : 'n3'"
                            :on="on"
                            icon="Flag"
                            @click="toggle_field('is_important')"
                        />
                    </template>
                    <span>{{ $t("Important") }}</span>
                </v-tooltip>
                <TaskSnoozeMenu
                    v-if="autoSave && !isTaskButton"
                    :task="taskData"
                    :open-towards-top="false"
                    :in-task-form="true"
                    @open-date-picker="focus_field('recurrence_rule')"
                    @openDatePicker="focus_field('recurrence_rule')"
                ></TaskSnoozeMenu>
                <v-menu
                    v-if="menuItems.length > 0"
                    left
                    offset-y
                    :transition="null"
                >
                    <template v-slot:activator="{ on }">
                        <icon-button
                            :on="on"
                            icon="MoreVertical"
                        />
                    </template>
                    <v-list dense>
                        <v-list-item
                            v-for="(item, i) in menuItems"
                            :key="i"
                            class="menu-list-item"
                            @click="action_click(item.action)"
                        >
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ item.title }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <div class="header-button-divider mx-2" :class="isRecurring ? 'n3' : 'n2'"></div>
                <v-tooltip
                    bottom
                    open-delay="250"
                >
                    <template v-slot:activator="{ on }">
                        <icon-button
                            :on="on"
                            icon="X"
                            @click="close_click"
                        />
                    </template>
                    <span>{{ $t("Close") }}</span>
                </v-tooltip>
            </div>
        </div>
    </div>
</template>
<script>
import TaskSnoozeMenu from "../TaskSnoozeMenu.vue";

export default {
    components: {
        TaskSnoozeMenu
    },
    props: {
        isFullPage: {
            type: Boolean,
            default: false
        },
        taskData: {
            type: Object,
            default: () => null
        },
        autoSave: {
            type: [Number, Boolean],
            default: 0
        },
        recurrenceRuleField: {
            type: Object,
            default: () => null
        },
        menuItems: {
            type: Array,
            default: () => []
        },
        isTaskButton: {
            type: Boolean,
            default: false
        },
        isRecurring: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const close_click = function () {
            ctx.emit('close_click');
        }

        const toggle_field = function (field_name) {
            ctx.emit('toggle_field', field_name)
        }

        const focus_field = function (field_name) {
            ctx.emit('focus_field', field_name);
        }

        const action_click = function (action) {
            ctx.emit('action_click', action)
        }

        return {
            toggle_field,
            action_click,
            close_click,
            focus_field
        };
    }
};
</script>
